import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldNumber = ({ value, onChange, ...props }) => {
  return <InputNumber className="w-full" value={value} onChange={onChange} {...props} />;
};

DynamicFieldNumber.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldNumber);
